const botmsg = state => state.botmsg;

const translation = state => state.translation;

export default {
  botmsg,
  translation
};



// WEBPACK FOOTER //
// ./src/store/modules/teachbot/getters.js